import { IAppState } from '@store/reducers';
import { ActiveIntegrationImport } from '@Integrations/types/integration';

export const getActiveIntegrationImport = (store: IAppState): ActiveIntegrationImport | undefined =>
    store.integrations.activeIntegrationImport;

export const getSidePanelError = (store: IAppState): boolean => store.integrations.sidePanelError;
